import { parseQueryState, removeFalsyObjKey } from '#helper';

export const getLabel = (device, meta) => meta?.device?.find(m => m.name === device.type)?.label;

export const typesToFilter = (types = [], withAllTypes) => {
  const res = types.map(el =>
    ({
      label: el.label,
      groupFilter: 'type',
      typeForRender: 'device type',
      fType: 'deviceType',
      value: el.name,
      searchType: el.name
    }));

  if (withAllTypes) {
    res.unshift({
      label: 'All types',
      groupFilter: 'type',
      typeForRender: 'device type',
      fType: 'deviceType',
      value: 'All types',
      searchType: 'All types'
    });
  }

  return res;
};

export const deviceTypesQR = ['beacon', 'beaconad0s0', 'beaconad0s1', 'beaconad1s0', 'beaconad1s1'];

/**
 * Build search params
 * @param {string} params - current search params.
 * @param {Array|Object} newParams - new search params.
 * @returns {string} - merged search params
 */

export const getSearchParams = (params, newParams) => {
  let searchParams;

  if (!newParams) {
    return '';
  }

  if (Array.isArray(newParams)) {
    const parsedCurrUrl = parseQueryState(params);
    searchParams = new URLSearchParams({
      ...parsedCurrUrl,
      ...{
        device: '',
        project: '',
        devicetype: ''
      }
    });
    const param = {
      device: [],
      project: [],
      page: [],
      order: [],
      orderBy: [],
      devicetype: []
    };
    newParams.forEach(el => {
      const { fType, type, value } = el;
      const t = fType || type;
      const lowerCaseType = t.toLowerCase();
      if (searchParams.has(lowerCaseType)) {
        param[lowerCaseType].push(value);
        searchParams.set(lowerCaseType, `${param[lowerCaseType].join(',')}`);
      } else {
        searchParams.set(lowerCaseType, value);
      }
    });
  } else {
    searchParams = new URLSearchParams(params);
    const { filterType, value, end, start } = newParams;

    if (filterType && value) {
      searchParams.set(filterType, value);
    }
    if (start && end) {
      searchParams.set('start', start);
      searchParams.set('end', end);
    }
  }

  const currentUrl = parseQueryState(params);
  const newUrl = parseQueryState(searchParams.toString());
  const mergedUrls = { ...currentUrl, ...newUrl };
  const url = new URLSearchParams(removeFalsyObjKey(mergedUrls));

  return `${url.toString()}`;
};
